/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Payout admin
 * Payout application
 * OpenAPI spec version: 1.0
 */

/**
 * Enum representing supported markets.
 */
export enum UniteTypeMarket {
    MARKET_UNSPECIFIED = 'MARKET_UNSPECIFIED',
    MARKET_BYBIT = 'MARKET_BYBIT',
    MARKET_BINANCE = 'MARKET_BINANCE',
}
